import { setRecoil } from 'recoil-nexus';
import { settingState } from '@/state/settingState';

export const removeSettingState = () => {
  setRecoil(settingState, undefined);
};
